import { render } from "./BaseDialog.vue?vue&type=template&id=0636e9fc&ts=true"
import script from "./BaseDialog.vue?vue&type=script&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&lang=ts"

import "./BaseDialog.vue?vue&type=style&index=0&id=0636e9fc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__